import React, { useEffect, useState } from 'react';
import './Settings.scss';
import * as R from 'ramda';
import ExplainTips from '../../utils/ExplainTips';
import { IOSSwitch } from '../../Switches/Switches';

import Select from 'react-select';

import { ReactComponent as SettingsIcon } from '../../../assets/icons/icon-settings-general.svg';
import { SoundService } from '../../../services/sound-service';
import { container } from 'tsyringe';
import { SettingService, SettingsKey } from '../../../services/setting-service';
import { useNotTooFast } from '../../hooks/useNotTooFast';


export interface QualitiesOption {
  readonly value: string;
  readonly label: string;
}
export const qualities: readonly QualitiesOption[] = [
  { value: '1080p', label: 'Full HD (1080p)' },
  { value: '720p', label: 'High Definition (720p)' },
  { value: '560p', label: 'Low Definition (560p)' },
];


const SettingsGeneral = () => {

  const [settingService] = useState(container.resolve(SettingService));

  const [soundService] = useState(container.resolve(SoundService));

  const [sounds, setSounds] = useState(soundService.sounds);

  const [settings, setSettings] = useState(
    {
      automaticAddStreamSharedScreen: settingService.getSetting(SettingsKey.automaticAddStreamSharedScreen),
      shiftVideosUp: settingService.getSetting(SettingsKey.shiftVideosUp),
      playSoundFx: settingService.getSetting(SettingsKey.playSoundFx),
      showAdvancedSettings: settingService.getSetting(SettingsKey.showAdvancedSettings),
    }
  )


  const checkNotTooFast = useNotTooFast(200);

  const toggleMoreSettings = () => {
    const value = !settings.showAdvancedSettings;
    setSettings({ ...settings, showAdvancedSettings: value });
    settingService.setSetting(SettingsKey.showAdvancedSettings, value);
  }

  const onToggleSound = (key) => {

    // toggleSound will also play it if it becomes true
    const updSounds = soundService.toggleSound(key);
    setSounds(R.clone(updSounds));

  }

  const onToggleSharedScreen = () => {
    if (checkNotTooFast()) {
      const value = !settings.automaticAddStreamSharedScreen;
      setSettings({ ...settings, automaticAddStreamSharedScreen: value });
      settingService.setSetting(SettingsKey.automaticAddStreamSharedScreen, value);
    }
  }

  // TODO : feature postponed in next release
  // const onToggleShiftVideosUp = () => {
  //   if (checkNotTooFast()) {
  //     const value = !settings.shiftVideosUp;
  //     setSettings({ ...settings, shiftVideosUp: value });
  //     settingService.setSetting(SettingsKey.shiftVideosUp, value);
  //   }
  // }

  const toggleGlobalPlaySound = () => {
    const value = !settings.playSoundFx;
    setSettings({ ...settings, playSoundFx: value });
    soundService.setGlobalPlaySound(value);
    settingService.setSetting(SettingsKey.playSoundFx, value);
  }

  const onSelectQuality = (value, action) => {
    console.log('quality', value, action);
  }

  return (
    <div className="settings-tab">
      <div className="title">
        <SettingsIcon className="icon" />
        <div>General Settings</div>
      </div>
      <ul className="items">

        <li key="quality">
          <div className="container">
            <div className="block">Broadcast Quality
              <ExplainTips text={'This is the quality of the stream we’ll use to send to Events, Facebook, Youtube, etc. Unless you have 1080p access on Facebook, viewers can only watch in 720p. 1080p is supported by YouTube, LinkedIn, and Twitch. You and your guests need a solid internet connection for 1080p to work well.'} tipStyle={{}}></ExplainTips>
            </div>
          </div>

          <div className="selector">
            <Select
              className="basic-single"
              classNamePrefix="select"
              defaultValue={qualities[0]}
              name="quality"
              options={qualities}
              onChange={onSelectQuality}
              isSearchable={false}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: '#f0f0f0',
                  primary50: '#4a4a4a',
                  primary: '#cbd2da',
                },
              })}
            />
          </div>
        </li>
        <li key="automaticAddShare">
          <div className="container">
            <div className="block">Automatically add shared screens to stream
              <ExplainTips text={'When you share your screen, we’ll automatically add it to the stream. Disable this if you want to queue up a shared screen without showing it right away. This doesn’t affect guests. Guest screen shares are never added automatically.'} tipStyle={{}}></ExplainTips>
            </div>
            <div className="block">
              <div>
                <IOSSwitch
                  className='switch'
                  checked={settings?.automaticAddStreamSharedScreen || false}
                  onChange={onToggleSharedScreen}
                />
              </div>
            </div>
          </div>
        </li>
        {/* <li key="shiftVideos">
          <div className="container">
            <div className="block">Shift videos up for comments/lower thirds
              <ExplainTips text={'Automatically shift videos up when comments and lower thirds are enabled to avoid covering guests in certain layouts'} tipStyle={{}}></ExplainTips>
            </div>
            <div className="block">
              <div>
                <IOSSwitch
                  className='switch'
                  checked={settings?.shiftVideosUp || false}
                  onChange={onToggleShiftVideosUp}
                />
              </div>
            </div>
          </div>
        </li> */}

        <li key="playSoundFX">
          <div className="container">
            <div className="block">Play Studio Sound FX
              <ExplainTips text={'Enable / Disable Studio Sound Effects'} tipStyle={{}}></ExplainTips>
            </div>
            <div className="block">
              <div>
                <IOSSwitch
                  className='switch'
                  checked={settings.playSoundFx}
                  onChange={toggleGlobalPlaySound}
                />
              </div>
            </div>
          </div>
        </li>

        <li key="advancedSettings">
          <div className="show-expand" onClick={() => toggleMoreSettings()}>
            Advanced Settings
            <div className={"caret " + (settings.showAdvancedSettings ? "on" : "off")}>&lsaquo;</div>
          </div>


          {settings.showAdvancedSettings &&
            <div className="container">
              <div className='block'>Play a sound when…</div>
            </div>
          }
        </li>

        {settings.showAdvancedSettings &&
          sounds.map(s =>
            <li key={s.key}>
              <div className="container-small">
                <div className="block">{s.label}
                </div>
                <div className="block">
                  <div>
                    <IOSSwitch
                      className='switch'
                      checked={s.checked}
                      onChange={() => onToggleSound(s.key)}
                    />
                  </div>
                </div>
              </div>
            </li>
          )
        }


      </ul>
    </div>
  )

}


export default SettingsGeneral;